import { swEnabled, swCommand, STORAGE_KEY } from '../engage_cache.js';
import {
    selectImageForPage,
    selectWordsURL,
    selectCoverImage,
} from '../selectors/content';
import { selectOfflineContentStatus } from '../selectors/offline';
import { sendCachedRequests } from './events.js';

export const CHECKOUT = 'CHECKOUT';
export const CHECKOUT_PROGRESS = 'CHECKOUT_PROGRESS';
export const CHECKIN_PROGRESS = 'CHECKIN_PROGRESS';
export const CHECKOUT_DONE = 'CHECKOUT_DONE';
export const RESET_STORE = 'RESET_STORE';
export const OFFLINE_READY = 'OFFLINE_READY';

export const CONNECTION_STATE = 'CONNECTION_STATE';

export const checkoutProgress = (contentId, total, done, error) => {
    return {
        type: CHECKOUT_PROGRESS,
        payload: {
            contentId,
            done,
            total,
            error,
        },
    };
};

export const checkinProgress = (contentId, done) => {
    return {
        type: CHECKIN_PROGRESS,
        payload: {
            contentId,
            done,
        },
    };
};

export const connectionState = up => dispatch => {
    if (up) {
        dispatch(sendCachedRequests());
    }
    return dispatch({
        type: CONNECTION_STATE,
        payload: up,
    });
};

export const resetStore = () => {
    return {
        type: RESET_STORE,
    };
};

export const setReadyStatus = () => {
    return {
        type: OFFLINE_READY,
    };
};

export const cacheImage = url => (dispatch, getState) => {
    // This is only intended for caching our content. Other images like Youtube
    // thumbnails get cached passively and can't live in our content cache
    // because of CORS.
    if (url != null && url.indexOf('cloudfront.net') > -1 && swEnabled) {
        swCommand('cacheImage', url);
    }

    return Promise.resolve(true);
};

export const cacheCover = content => (dispatch, getState) => {
    const cover = selectCoverImage(getState(), content);
    return dispatch(cacheImage(cover));
};

const checkout = content => (dispatch, getState) => {
    const state = getState();

    const pages = content.pages.map(p => ({
        image: selectImageForPage(state, content, p.pagenum),
        words: selectWordsURL(state, content, p.pagenum),
    }));

    swCommand('checkoutContent', content.id, content.slug, pages);
};

const checkin = content => {
    swCommand('checkinContent', content.id, content.slug);
    return checkinProgress(content.id, false);
};

export const toggleOffline = content => (dispatch, getState) => {
    const status = selectOfflineContentStatus(getState(), content);
    if (status == null || status.error != null) {
        return dispatch(checkout(content));
    } else {
        return dispatch(checkin(content));
    }
};

export const upgradeServiceWorker = () => dispatch => {
    console.log('Reloading to pick up new version'); // eslint-disable-line no-console
    window.location.reload();
};

export const uninstallComplete = () => dispatch => {
    localStorage.removeItem(STORAGE_KEY);
    window.location.reload();
};

// store.dispatch(checkout(store.getState().content.content[3]))
global.checkout = checkout;



// WEBPACK FOOTER //
// ./src/actions/offline.js